<template>
    <div class="com-item opticalRnd-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">
                <div class="opticalRnd-module__inner">
                    <div class="opticalRnd-module__left">
                        <div class="opticalRnd-module__title" v-if="W.enTitle || W.cnTitle">
                            <h2 class="opticalRnd-module__cn" v-if="W.cnTitle">{{ W.cnTitle }}</h2>
                            <p class="opticalRnd-module__line"></p>
                            <p class="opticalRnd-module__en" v-if="W.enTitle">{{ W.enTitle }}</p>
                        </div>
                        <div class="opticalRnd-module__desc" v-html="W.describeHtml"></div>

                        <ul class="opticalRnd-module__points" v-if="W.points && W.points.length">
                            <li class="opticalRnd-module__point" v-for="(p, idx) in W.points" :key="idx">
                                <span class="opticalRnd-module__point-icon" v-if="p.iconUrl">
                                    <img :src="p.iconUrl" alt="" />
                                </span>
                                <span class="opticalRnd-module__point-title">{{ p.title }}</span>
                            </li>
                        </ul>
                    </div>

                    <div class="opticalRnd-module__right" v-if="W.imageUrl">
                        <img :src="W.imageUrl" class="opticalRnd-module__img" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEFAULT_IMG = 'https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202607/ScreenShot_2026-07-03_152303_32803152310271.png'

export default {
    name: 'opticalRnd-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'opticalRnd',
                    Title: '光学研发实力',
                    MID: 34,
                    ModuleName: 'opticalRndModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            defaultData: {
                bgColor: '',
                textColor: '',
                enTitle: 'OPTICAL R&D',
                cnTitle: '光学研发实力',
                describeHtml: '<p>AES 拥有专业的光学设计与仿真能力，掌握核心光学技术，通过光学设计、光学模拟和光学测试，不断优化光学性能，实现更远照射距离、更宽照明范围和更均匀的光型效果。</p>',
                points: [
                    { iconUrl: DEFAULT_IMG, title: '专业光学设计团队' },
                    { iconUrl: DEFAULT_IMG, title: 'Zemax 光学仿真分析' },
                    { iconUrl: DEFAULT_IMG, title: '多重光学优化设计' },
                    { iconUrl: DEFAULT_IMG, title: '光学测试与验证' }
                ],
                imageUrl: DEFAULT_IMG
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.points) || !this.modata.WContent.points.length) {
            this.$set(this.modata.WContent, 'points', JSON.parse(JSON.stringify(this.defaultData.points)))
        }
    },
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.opticalRnd-module {
    margin-bottom: 30px;

    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 2% 0;
    }

    .opticalRnd-module__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        position: relative;
    }

    .opticalRnd-module__left {
        flex: 0 0 35%;
        max-width: 35%;
        box-sizing: border-box;
        padding-right: 4%;
    }

    .opticalRnd-module__right {
        flex: 1;
        min-width: 0;
    }

    .opticalRnd-module__title {
        margin-bottom: 24px;
    }

    .opticalRnd-module__cn {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        line-height: 1.3;
        margin: 0 0 8px;
    }

    .opticalRnd-module__line {
        width: 48px;
        height: 3px;
        background: #e60012;
        margin: 0 0 12px;
    }

    .opticalRnd-module__en {
        font-size: 14px;
        color: #999;
        letter-spacing: 2px;
        line-height: 1.4;
        margin: 0;
    }

    .opticalRnd-module__desc {
        font-size: 16px;
        color: #555;
        line-height: 1.8;
        margin: 0 0 32px;

        ::v-deep p {
            margin: 0;
            text-indent: 2em;
        }
    }

    .opticalRnd-module__points {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .opticalRnd-module__point {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .opticalRnd-module__point-icon {
        width: 28px;
        height: 28px;
        flex: none;
        margin-right: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .opticalRnd-module__point-title {
        font-size: 16px;
        color: #333;
        line-height: 1.4;
    }

    .opticalRnd-module__img {
        display: block;
        width: 100%;
        height: auto;
    }
}

@media screen and (max-width: 768px) {

    .opticalRnd-module {
        margin-bottom: 5px;
        .opticalRnd-module__inner {
            flex-direction: column-reverse;
            padding-top: 110px;
        }
        .opticalRnd-module__title{
            position: absolute;
            top: 0;
            left: 0;
        }

        .opticalRnd-module__left {
            flex: 0 0 100%;
            max-width: 100%;
            padding-right: 0;
        }
        .opticalRnd-module__desc{
          font-size: 18px;
          margin-bottom: 16px;
        }
        .opticalRnd-module__points{
            display: flex;
            flex-wrap: wrap;
        }
        .opticalRnd-module__point{
            width: 50%;
        }
        .opticalRnd-module__point-icon{
            width: 34px;
            height: 34px;
             margin-right: 8px;
        }

        .opticalRnd-module__right {
            flex: 0 0 100%;
            width: 100%;
            margin-bottom: 12px;
        }
    }
}
</style>